export default "__VITE_ASSET__C77_VT0U__"